module.exports = __webpack_public_path__ + "static/PatKT-04-9bf0ae94a0501a22cd5bc43a50a2c57d.jpg";